export class IconTypes {
  private _ICON_TYPES: Map<string, any>;

  public types(typeString: string): string {
    // typeString = typeString.toLowerCase();
    return this._ICON_TYPES.get(typeString.toLowerCase()) || 'fas fa-file-alt';
  }
  /**
   *
   */
  constructor() {
    this._ICON_TYPES = new Map();
    this._ICON_TYPES.set('link', 'fas fa-external-link-square-alt');
    this._ICON_TYPES.set('youtube', 'red fab fa-youtube');
    this._ICON_TYPES.set('pdf', 'red fas fa-file-pdf');
    this._ICON_TYPES.set('ppt', 'orange fas fa-file-powerpoint');
    this._ICON_TYPES.set('pptx', 'orange fas fa-file-powerpoint');
    this._ICON_TYPES.set('doc', 'blue fas fa-file-word');
    this._ICON_TYPES.set('docx', 'blue fas fa-file-word');
    this._ICON_TYPES.set('ods', 'blue fas fa-file-word');
    this._ICON_TYPES.set('xls', 'green fas fa-file-excel');
    this._ICON_TYPES.set('xlsx', 'green fas fa-file-excel');
    this._ICON_TYPES.set('png', 'fas fa-file-image');
    this._ICON_TYPES.set('bmp', 'fas fa-file-image');
    this._ICON_TYPES.set('jpeg', 'fas fa-file-image');
    this._ICON_TYPES.set('jpg', 'fas fa-file-image');
    this._ICON_TYPES.set('gif', 'fas fa-file-image');
    this._ICON_TYPES.set('avi', 'fas fa-file-video');
    this._ICON_TYPES.set('mp4', 'fas fa-file-video');
    this._ICON_TYPES.set('mp3', 'fas fa-file-audio');
    this._ICON_TYPES.set('rar', 'fas fa-file-archive');
    this._ICON_TYPES.set('zip', 'fas fa-file-archive');
  }
}
